const CACHE__ZOOM_LEVEL = 'dashboard_map__zoom'
const CACHE__CENTER_X = 'dashboard_map__center__longitude'
const CACHE__CENTER_Y = 'dashboard_map__center__latitude'

const DEFAULT_CENTER = {
    lat: 37.5759,
    lng: 126.9768
}
const DEFAULT_ZOOM = 18

const getStoredNumber = (key: string) => {
    const rawValue = localStorage.getItem(key)
    if (!rawValue) return undefined

    const value = Number(rawValue)
    return Number.isFinite(value) ? value : undefined
}

const isValidLatitude = (value?: number) => (
    typeof value === 'number' && Number.isFinite(value) && value >= -90 && value <= 90
)

const isValidLongitude = (value?: number) => (
    typeof value === 'number' && Number.isFinite(value) && value >= -180 && value <= 180
)

const isValidZoom = (value?: number) => (
    typeof value === 'number' && Number.isFinite(value) && value >= 1 && value <= 21
)

export const getDashboardMapCenter = (fallbackLat?: number, fallbackLng?: number) => {
    const cachedLat = getStoredNumber(CACHE__CENTER_Y)
    const cachedLng = getStoredNumber(CACHE__CENTER_X)

    if (isValidLatitude(cachedLat) && isValidLongitude(cachedLng)) {
        return {
            lat: cachedLat as number,
            lng: cachedLng as number
        }
    }

    localStorage.removeItem(CACHE__CENTER_Y)
    localStorage.removeItem(CACHE__CENTER_X)

    const lat = isValidLatitude(fallbackLat) ? fallbackLat as number : DEFAULT_CENTER.lat
    const lng = isValidLongitude(fallbackLng) ? fallbackLng as number : DEFAULT_CENTER.lng

    return {
        lat,
        lng
    }
}

export const getDashboardMapZoom = () => {
    const cachedZoom = getStoredNumber(CACHE__ZOOM_LEVEL)
    if (isValidZoom(cachedZoom)) return cachedZoom as number

    localStorage.removeItem(CACHE__ZOOM_LEVEL)
    return DEFAULT_ZOOM
}

export const setDashboardMapCenter = (lat?: number, lng?: number) => {
    if (!isValidLatitude(lat) || !isValidLongitude(lng)) {
        localStorage.removeItem(CACHE__CENTER_Y)
        localStorage.removeItem(CACHE__CENTER_X)
        return
    }

    localStorage.setItem(CACHE__CENTER_Y, (lat as number).toString())
    localStorage.setItem(CACHE__CENTER_X, (lng as number).toString())
}

export const setDashboardMapZoom = (zoom?: number) => {
    if (!isValidZoom(zoom)) {
        localStorage.removeItem(CACHE__ZOOM_LEVEL)
        return
    }

    localStorage.setItem(CACHE__ZOOM_LEVEL, (zoom as number).toString())
}
